import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../Login.module.scss';

const { Button, Box, Title } = vp;

type TwoFactorAuthenticationInfoProps = {
  handleContinue: () => void;
};

type FC = FunctionComponent<TwoFactorAuthenticationInfoProps>;
const TwoFactorAuthenticationInfo: FC = (props: TwoFactorAuthenticationInfoProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TwoFactorAuthenticationInfo' });
  const { handleContinue } = props;
  return (
    <Box flx="col">
      <Box mb="sm" flx="col" ai="center" height="auto">
        <Title title={t('title', { defaultValue: 'Multi-factor Authentication' })} bold size="xsm" />
      </Box>
      <div className={styles.loginDescription}>
        {t('description1', {
          defaultValue:
            'Multi-factor Authentication protects your VoPay account by requiring a second login step. That second step keeps your account secure, even if your password is compromised.',
        })}
      </div>
      <div className={styles.loginDescription}>
        {t('description2', {
          defaultValue:
            'In order to enable Multi-factor Authentication you will need to install an authentication app. We support most authentication apps – some of the more common ones:',
        })}
      </div>
      <ul className={styles.authenticatorList}>
        <li>Google Authenticator</li>
        <li>Microsoft Authenticator</li>
        <li>Authy</li>
        <li>LastPass Authenticator</li>
        <li>Duo Mobile</li>
        <li>Apple Two-Factor Authentication</li>
      </ul>
      <Box jc="fe" flx="col" height="auto">
        <Button
          id="enable-2-fa"
          type="button"
          label={t('enable', { defaultValue: 'Enable' })}
          size="xlg"
          textSize={1}
          onClick={() => {
            handleContinue();
          }}
        />
      </Box>
    </Box>
  );
};
export default TwoFactorAuthenticationInfo;
